import React, { useEffect, useState } from 'react';
import './IceCreamBanner.css';

const IceCreamBanner = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (isMobile) {
    return (
      <section className="ice-cream-banner ice-cream-banner--mobile">
        <img
          src="/assets/new1.png"
          alt=""
          className="ice-cream-banner-drip"
          aria-hidden="true"
        />
        <div className="ice-cream-banner-text">IceCream</div>
      </section>
    );
  }

  // Desktop version (use /assets/ice-bg.png as background)
  return (
    <section
      className="ice-cream-banner"
      style={{
        backgroundImage: "url('/assets/nov-bg.png')",
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundSize: 'cover',
        minHeight: '22vh',
        display: 'flex',
        alignItems: 'center',
        position: 'relative'
      }}
    >
      <div className="ice-cream-banner-text">IceCream</div>
    </section>
  );
};

export default IceCreamBanner; 